import { fromJS } from 'immutable/dist/immutable';
import { normalizeInitialFormValues, fieldToNumber, fieldTrimmed } from '../../../../../form/formUtilities';

export const createInitialForm = volcanoEvent => fromJS({
  id: normalizeInitialFormValues(volcanoEvent, ['id']),
  year: normalizeInitialFormValues(volcanoEvent, ['year']),
  month: normalizeInitialFormValues(volcanoEvent, ['month']),
  day: normalizeInitialFormValues(volcanoEvent, ['day']),
  startDate: normalizeInitialFormValues(volcanoEvent, ['startDate']),
  endDate: normalizeInitialFormValues(volcanoEvent, ['endDate']),
  vei: normalizeInitialFormValues(volcanoEvent, ['vei']),
  deaths: normalizeInitialFormValues(volcanoEvent, ['deaths']),
  agent: normalizeInitialFormValues(volcanoEvent, ['agent']),
  comments: normalizeInitialFormValues(volcanoEvent, ['comments']),
  damageMillionsDollars: normalizeInitialFormValues(volcanoEvent, ['damageMillionsDollars']),
  damageAmountOrder: normalizeInitialFormValues(volcanoEvent, ['damageAmountOrder']),
  deathsAmountOrder: normalizeInitialFormValues(volcanoEvent, ['deathsAmountOrder']),
  injuries: normalizeInitialFormValues(volcanoEvent, ['injuries']),
  injuriesAmountOrder: normalizeInitialFormValues(volcanoEvent, ['injuriesAmountOrder']),
  housesDestroyed: normalizeInitialFormValues(volcanoEvent, ['housesDestroyed']),
  housesDestroyedAmountOrder: normalizeInitialFormValues(volcanoEvent, ['housesDestroyedAmountOrder']),
  missing: normalizeInitialFormValues(volcanoEvent, ['missing']),
  missingAmountOrder: normalizeInitialFormValues(volcanoEvent, ['missingAmountOrder']),
  deathsTotal: normalizeInitialFormValues(volcanoEvent, ['deathsTotal']),
  deathsAmountOrderTotal: normalizeInitialFormValues(volcanoEvent, ['deathsAmountOrderTotal']),
  injuriesTotal: normalizeInitialFormValues(volcanoEvent, ['injuriesTotal']),
  injuriesAmountOrderTotal: normalizeInitialFormValues(volcanoEvent, ['injuriesAmountOrderTotal']),
  missingTotal: normalizeInitialFormValues(volcanoEvent, ['missingTotal']),
  missingAmountOrderTotal: normalizeInitialFormValues(volcanoEvent, ['missingAmountOrderTotal']),
  damageMillionsDollarsTotal: normalizeInitialFormValues(volcanoEvent, ['damageMillionsDollarsTotal']),
  damageAmountOrderTotal: normalizeInitialFormValues(volcanoEvent, ['damageAmountOrderTotal']),
  housesDestroyedTotal: normalizeInitialFormValues(volcanoEvent, ['housesDestroyedTotal']),
  housesDestroyedAmountOrderTotal: normalizeInitialFormValues(volcanoEvent, ['housesDestroyedAmountOrderTotal']),
  significant: normalizeInitialFormValues(volcanoEvent, ['significant'], true),
  tsunamiEventId: normalizeInitialFormValues(volcanoEvent, ['tsunamiEventId']),
  earthquakeEventId: normalizeInitialFormValues(volcanoEvent, ['earthquakeEventId']),
  volcanoLocationId: normalizeInitialFormValues(volcanoEvent, ['volcanoLocationId']),
  referenceIds: volcanoEvent && volcanoEvent.get('referenceIds') ? volcanoEvent.get('referenceIds').map(v => `${v}`) : [],
  publish: normalizeInitialFormValues(volcanoEvent, ['publish'], true),
  eruption: normalizeInitialFormValues(volcanoEvent, ['eruption'], true),
});

export const volcanoEventEditModel = fromJS({
  name: 'volcanoEventEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  year: fieldToNumber(form.get('year')),
  month: fieldToNumber(form.get('month')),
  day: fieldToNumber(form.get('day')),
  startDate: fieldTrimmed(form.get('startDate')),
  endDate: fieldTrimmed(form.get('endDate')),
  vei: fieldToNumber(form.get('vei')),
  deaths: fieldToNumber(form.get('deaths')),
  agent: fieldTrimmed(form.get('agent')),
  comments: fieldTrimmed(form.get('comments')),
  damageMillionsDollars: fieldToNumber(form.get('damageMillionsDollars')),
  damageAmountOrder: fieldToNumber(form.get('damageAmountOrder')),
  deathsAmountOrder: fieldToNumber(form.get('deathsAmountOrder')),
  injuries: fieldToNumber(form.get('injuries')),
  injuriesAmountOrder: fieldToNumber(form.get('injuriesAmountOrder')),
  housesDestroyed: fieldToNumber(form.get('housesDestroyed')),
  housesDestroyedAmountOrder: fieldToNumber(form.get('housesDestroyedAmountOrder')),
  missing: fieldToNumber(form.get('missing')),
  missingAmountOrder: fieldToNumber(form.get('missingAmountOrder')),
  deathsTotal: fieldToNumber(form.get('deathsTotal')),
  deathsAmountOrderTotal: fieldToNumber(form.get('deathsAmountOrderTotal')),
  injuriesTotal: fieldToNumber(form.get('injuriesTotal')),
  injuriesAmountOrderTotal: fieldToNumber(form.get('injuriesAmountOrderTotal')),
  missingTotal: fieldToNumber(form.get('missingTotal')),
  missingAmountOrderTotal: fieldToNumber(form.get('missingAmountOrderTotal')),
  damageMillionsDollarsTotal: fieldToNumber(form.get('damageMillionsDollarsTotal')),
  damageAmountOrderTotal: fieldToNumber(form.get('damageAmountOrderTotal')),
  housesDestroyedTotal: fieldToNumber(form.get('housesDestroyedTotal')),
  housesDestroyedAmountOrderTotal: fieldToNumber(form.get('housesDestroyedAmountOrderTotal')),
  significant: Boolean(form.get('significant')),
  tsunamiEventId: fieldToNumber(form.get('tsunamiEventId')),
  earthquakeEventId: fieldToNumber(form.get('earthquakeEventId')),
  volcanoLocationId: fieldToNumber(form.get('volcanoLocationId')),
  referenceIds: fromJS(form.get('referenceIds')).map(fieldToNumber).filter(value => value != null),
  publish: Boolean(form.get('publish')),
  eruption: Boolean(form.get('eruption')),
});
